/**
 * Reads title and body from a prebuilt legal HTML document (browser only).
 *
 * @param {string} html
 * @returns {{ title: string, content: string }}
 */
export default function parseLegalHtml(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    return {
        title: doc.title,
        content: doc.body.innerHTML,
    };
}
